import React, { useState } from "react";
import Icon1 from "../icons/Icon";
import Space from "../layout/Space";

interface NavBarButtonProps {
  premium?: boolean | number;
  parameter?: boolean;
  icon: string;
  children?: React.ReactNode;
  alert?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  actualpage?: any;
  isActualPage?: boolean;
  squeezed?: boolean;
  light?: boolean;
}

function NavBarButton({
  premium = false,
  parameter = false,
  icon,
  children,
  alert = false,
  onClick,
  className,
  actualpage,
  isActualPage = false,
  squeezed = false,
  light = true,
}: NavBarButtonProps) {
  const [hover, setHover] = useState(false);

  return (
    <button
      className={`w-full px-2 ${
        squeezed ? "py-0" : "py-1"
      }  rounded-md font-medium flex items-center transition-all ${
        isActualPage
          ? "bg-shadow_5 text-black border-shadow_50 "
          : hover
          ? "bg-shadow_5 text-black border-transparent "
          : "bg-transparent text-black border-transparent "
      } shadow-none hover:shadow-none border-l-2 ${className}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={onClick}
    >
      <div className="flex flex-row justify-start w-full items-center relative">
        {alert && (
          <div className="absolute left-3 top-3 h-2 w-2 rounded-full bg-red-500"></div>
        )}
        <Icon1
          icon_name={icon}
          fill={
            alert
              ? "red"
              : isActualPage || hover
              ? premium
                ? "#8b5cf6"
                : "black"
              : "grey"
          }
        />
        <Space x={15} />
        <div
          className={`text-h3  flex flex-row gap-2
            ${isActualPage || hover ? "text-black" : "text-shadow_50"}
            `}
        >
          {children}
        </div>
      </div>
    </button>
  );
}

export default NavBarButton;
